<script lang="ts">
  import { onMount } from "svelte";
  import { db } from "../firebase";
  import { doc, updateDoc } from "@firebase/firestore";

  import { IconButtonType, ModalCss, DocType } from "../enums";

  import { Icons } from "../utilities/icons";

  import Modal from "../components/Modal.svelte";
  import IconButton from "../components/IconButton.svelte";

  // PROPS ------------------------------------------------

  let {
    email = $bindable(),
    name = $bindable(),
    active = $bindable(),
    userEdited,
    editUserDialogCanceled,
  } = $props();

  // CONSTANTS --------------------------------------------

  // STATE --------------------------------------------------

  let oldEmail: string;
  let oldNname: string;
  let oldActive: boolean;

  // FUNCTIONS ---------------------------------------------

  // button clicks ---

  const saveEdit = async (e: SubmitEvent) => {
    e.preventDefault();
    const documentRef = doc(db, DocType.Users, email);
    try {
      await updateDoc(documentRef, {
        name: name,
        active: active,
      });
    } catch (err) {
      console.error("kunne ikke opdatere logopæd: ", email, " fejl: ", err);
    } finally {
      userEdited();
    }
  };

  const cancel = () => {
    email = oldEmail;
    name = oldNname;
    active = oldActive;
    editUserDialogCanceled();
  };

  // INITIALIZE --------------------------------------

  onMount(() => {
    // enable cancel without changing
    oldEmail = email;
    oldNname = name;
    oldActive = active;
  });
</script>

<!-- HTML ===================================================== -->

<Modal size={ModalCss.Size.Large}>
  <form onsubmit={saveEdit}>
    <div class="headline">
      <h1>Indstillinger</h1>
    </div>
    <div class="content">
      <p>E-mail: {email}</p>
      <div class="input">
        <label for="name">Kalde-navn:</label>
        <input type="text" id="name" bind:value={name} />
      </div>
      <div class="check">
        <input type="checkbox" id="onestep" bind:checked={active} />
        <label for="onestep">Aktiv</label>
      </div>
    </div>
    <div class="bottom-box">
      <IconButton
        onclick={cancel}
        textMediumScaled={true}
        icon={Icons.WindowClose}
      >
        {#snippet message()}Fortryd{/snippet}
      </IconButton>
      <span class="ok-btn">
        <IconButton
          textMediumScaled={true}
          type={IconButtonType.Submit}
          icon={Icons.Check}
          onclick={saveEdit}
        >
          {#snippet message()}Gem{/snippet}
        </IconButton>
      </span>
    </div>
  </form>
</Modal>

<!-- CSS ===================================================== -->
<style>
  form {
    height: 100%;
    padding: 2vmin;
  }
  h1 {
    font-size: 4vmin;
    margin-bottom: 2vmin;
  }
  .content {
    display: flex;
    flex-direction: column;
    font-size: 2.5vmin;
    justify-content: space-between;
    align-items: flex-start;
    padding-top: 1.5vmin;
    padding-bottom: 3vmin;
  }
  .bottom-box {
    display: flex;
    justify-content: space-between;
  }
  .input,
  .check {
    padding-top: 2vmin;
  }
  .input {
    width: 100%;
  }
  input[type="text"] {
    font-size: 2.5vmin;
    width: 70%;
  }
  input[type="checkbox"] {
    margin-right: 1vmin;
    font-size: 2.5vmin;
  }
</style>
